import { TFunction } from 'i18next';

import { FullProject, LoggedUser, projectStatusConfig } from 'entities';

import { determineProjectCanBeCompleted, isInvoiceRepriceActive } from './utils';

export const projectTabs = {
  execution: 'execution',
  invoice: 'invoice',
  finish: 'finish',
  issues: 'issues',
  recruitments: 'recruitments',
  tracking: 'tracking',
} as const;

export type Tab = keyof typeof projectTabs;

export function getProjectActiveTabs(project: FullProject | undefined, user: LoggedUser) {
  const isDone = project?.status === projectStatusConfig.done.code;

  return [
    { value: 'execution', getLabel: (t: TFunction) => t('execution') },

    { value: 'invoice', getLabel: (t: TFunction) => t('invoice') },

    {
      value: 'tracking',

      getLabel: (t: TFunction) => t('tracking'),

      render: [
        project?.type === 'TRACKER_ORIGIN',
        project?.type === 'TRACKER_SEQUENCE',
        //
      ].some(Boolean),
    },

    {
      value: 'issues',

      getLabel: (t: TFunction) =>
        `${t('issues')}${project?.activeIssues ? ` (${project?.activeIssues})` : ''}`,
    },

    {
      value: 'recruitments',

      getLabel: (t: TFunction) =>
        `${t('recruitments')}${
          project?.activeRecruitments ? ` (${project?.activeRecruitments})` : ''
        }`,
    },

    {
      value: 'finish',

      getLabel: (t: TFunction) => t(isDone ? 'closure-form' : 'finish'),

      render: [
        isDone ? true : !isInvoiceRepriceActive(project),
        (isDone && !project?.legacy) || determineProjectCanBeCompleted(project, user),
        !project?.activeIssues,
        !project?.activeRecruitments,
      ].every(Boolean),
    },
  ];
}
